/**
 * Utilidades centralizadas para resolver la URL pública de la tienda online (Storefront)
 * de forma dinámica según la óptica activa.
 */

export const DEFAULT_STOREFRONT_BASE_URL = 'https://optica-store-front.vercel.app';

/**
 * Obtiene la URL base del storefront, priorizando la variable de entorno REACT_APP_STOREFRONT_URL
 * y removiendo barras finales para evitar dobles barras en la concatenación.
 */
export function getStorefrontBaseUrl() {
  const envUrl = process.env.REACT_APP_STOREFRONT_URL;
  if (envUrl && typeof envUrl === 'string' && envUrl.trim()) {
    return envUrl.trim().replace(/\/+$/, '');
  }
  return DEFAULT_STOREFRONT_BASE_URL;
}

/**
 * Retorna la URL completa y dinámica de la tienda online para una óptica dada su slug.
 * Si no se proporciona slug, devuelve la URL base sin romper el enlace.
 * Ejemplos:
 *   getStorefrontUrl('hl-optica') -> 'https://optica-store-front.vercel.app/hl-optica'
 *   getStorefrontUrl('cristalio-optica') -> 'https://optica-store-front.vercel.app/cristalio-optica'
 *   getStorefrontUrl('optica-prueba') -> 'https://optica-store-front.vercel.app/optica-prueba'
 */
export function getStorefrontUrl(slug) {
  const baseUrl = getStorefrontBaseUrl();
  if (!slug || typeof slug !== 'string' || !slug.trim()) {
    return baseUrl;
  }
  const cleanSlug = slug.trim().replace(/^\/+|\/+$/g, '');
  return `${baseUrl}/${cleanSlug}`;
}

